import { SearchCategories } from "@nosto/nosto-js/client";
import Category from "../Item/Category";

export type CategoriesProps = {
  categories: SearchCategories;
};

export default function Categories({ categories }: CategoriesProps) {
  if (!categories?.hits?.length) {
    return null;
  }

  return (
    <>
      <h4>Collections</h4>
      <div>
        {categories.hits.map((category, index) => (
          <Category key={index} category={category} />
        ))}
      </div>
    </>
  );
}
